<template>
<div>
    <form>
        <div class="row">
            <div class="form-group col-12 col-lg-12">
                <label for="title">
                    {{ $lang('Nazwa') }}
                    <span class="text-red">({{ $lang('wymagane') }})</span>
                </label>
                <div class="input-group-prepend">
                    <div class="bg-icon">
                        <i aria-hidden="true" class="fa fa-envelope-o"></i>
                    </div>
                    <input class="form-control" id="name" name="name" v-model="name" type="text"
                           :placeholder="$lang('Nazwa')" >
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-lg-12">
                <label for="cms-editor-content">
                    {{ $lang('Treść') }}
                    <span class="text-red">({{ $lang('wymagane') }})</span>
                </label>
                <vue-editor id="cms-editor-content" ref="editoralert"
                            v-model="content"
                            @text-change="changeAlertContent"
                            useCustomImageHandler
                            @image-added="handleImageAdded"
                            :editorOptions="editorSettings"
                            @mouseover.native="editor = 'cms-editor-content'"
                >
                </vue-editor>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-lg-12">
                <label for="cms-editor-footer">
                    {{ $lang('Stopka') }}
                    <span class="text-red">({{ $lang('wymagane') }})</span>
                </label>
                <vue-editor id="cms-editor-footer" ref="editoralert"
                            v-model="footer"
                            @text-change="changeAlertContent"
                            useCustomImageHandler
                            @image-added="handleImageAdded"
                            :editorOptions="editorSettings"
                            @mouseover.native="editor = 'cms-editor-footer'"
                >
                </vue-editor>
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 float-right my-2">
            <button class="btn btn-primary float-right ml-2" type="submit" @click.prevent="save">
                {{ $lang('Zapisz') }}
            </button>
            <button class="btn btn-default float-right ml-2" type="submit" @click.prevent="showPreviewModal">
                {{ $lang('Podgląd') }}
            </button>
        </div>
    </form>

    <div class="modal fade" id="preview_modal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-email">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$lang('Podgląd')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-html="content"></div>
                    <hr class="w-100 m-0">
                    <small v-html="footer"></small>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" id="close">
                        {{$lang('Zamknij')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import Notification from '../../../mixins/show-notification';
import axios from "axios";
import EditorArias from '../../../mixins/cms-editor-arias';
import Quill from "quill";
import ImageResize from "quill-image-resize-module";
import QuillImageDropAndPaste from "quill-image-drop-and-paste";

Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste, true);
Quill.register('modules/imageResize', ImageResize, true);
export default {
    name: "template-form",
    components: {VueEditor},
    mixins: [Notification, EditorArias],
    props: {
        add_route: {
            type: String,
        },
        update_route: {
            type: String,
        },
        templates_route: {
            type: String,
        },
        upload_image_route: {
            type: String,
        },
        template: {
            type: Object,
        }
    },
    data() {
        return {
            editorSettings: {
                modules: {
                    imageResize: {},
                    imageDropAndPaste: {
                        handler: this.handleImageDropPaste,
                    },
                },
            },
            name: this.template ? this.template.name : '',
            content: this.template ? this.template.content :  '',
            footer: this.template ? this.template.footer :  '',
            editor: null,
        }
    },
    methods: {
        handleImageDropPaste(imageDataUrl, type, imageData) {
            const file = imageData.toFile();
            const formData = new FormData();

            //Show notification when file >= 5MB
            if (imageData.size >= 5242880) {
                this.showNotification('error', this.$lang('Za duży rozmiar pliku. (Maksymalny rozmiar: 5MB)'));
                return;
            }

            formData.append('image', file);

            axios.post(this.upload_image_route, formData)
                .then(result => {
                    let url = result.data.url; // Get url from response
                    let container = document.querySelector('#' + this.editor);
                    let editor = Quill.find(container);
                    let index = (editor.getSelection() || {}).index;

                    if (index === undefined || index < 0) {
                        index = editor.getLength();
                    }
                    editor.insertEmbed(index, 'image', url);
                })
                .catch(err => {
                    const errors = err.response.data.errors;
                    if (errors) {
                        Object.values(errors).forEach(error => {
                            error.forEach(message => this.showNotification('error', this.$lang(message)));
                        });
                    }
                });
        },
        handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            let formData = new FormData();
            //Show notification when file >= 5MB
            if (file.size >= 5242880) {
                this.showNotification('error', this.$lang('Za duży rozmiar pliku. (Maksymalny rozmiar: 5MB)'));
                return;
            }
            formData.append("image", file);

            axios.post(this.upload_image_route,  formData)
                .then(result => {
                    let url = result.data.url;
                    Editor.insertEmbed(cursorLocation, "image", url);
                    resetUploader();
                })
                .catch(err => {
                    console.log(err);
                    this.showNotification('error', this.$lang('Wystąpił błąd podczas dodawania zdjęcia.'));
                });
        },

        addTemplate() {
            let params = {
                name: this.name,
                content: this.content,
                footer: this.footer,
            }

            axios.post(this.add_route, params
            ).then(response => {
                this.showNotification('success', this.$lang('Szablon utworzony pomyślnie.'));
                window.location.href = this.templates_route;
            }).catch(err => {
                console.log(err);
            });
        },

        updateTemplate() {
            let params = {
                id: this.template.id,
                name: this.name,
                content: this.content,
                footer: this.footer,
            }

            axios.patch(this.update_route, params
            ).then(response => {
                this.showNotification('success', this.$lang('Szablon zapisano pomyślnie.'));
                window.location.href = this.templates_route;
            }).catch(err => {
                console.log(err);
                this.showNotification('error', this.$lang('Wystąpił błąd.'));
            });
        },

        changeAlertContent(e) {
            let component = this;
            e.forEach(function (ops) {
                if (ops.hasOwnProperty('insert') && typeof ops.insert.charCodeAt === 'function' && ops.insert.charCodeAt(0) === 9) { //tabulation
                    if(typeof component.$refs.editoralert.forEach === 'function') {
                        component.$refs.editoralert.forEach(function (item) {
                            window.setTimeout(function () {
                                jQuery('#saveContentAlert').focus();
                            }, 0);
                        });
                    }
                }
            });
        },

        showPreviewModal() {
            $("#preview_modal").modal("show");
        },

        save() {
            if (this.template) {
                this.updateTemplate();
            } else {
                this.addTemplate();
            }
        }
    },
}
</script>
